export function getSide(side){
    return{
        type:'GET_SIDE',
        payload:side
    }
}